const lineText = document.querySelector('.js-profitable-proposition__top-text-line');

const isElementInViewport = (el) => {
	const rect = el.getBoundingClientRect();

	return rect.top >= 0 && rect.bottom <= window.innerHeight;
};

if (lineText) {
	let index = 0;
	const links = lineText.querySelectorAll('a');

	Array.from(links).forEach((link) => {
		let template = '';
		const words = link.textContent.split(' ');

		words.forEach((word) => {
			template += ` <span style='--index:${index}'>${word}</span> `;
			index += 1;
		});

		// eslint-disable-next-line no-param-reassign
		link.innerHTML = template;
	});

	const callback = () => {
		if (isElementInViewport(lineText)) {
			window.removeEventListener('scroll', callback);

			setTimeout(() => {
				lineText.classList.add('init');
			}, 100);
		}
	};

	window.addEventListener('scroll', callback);

	callback();
}
